import React from "react";
import { ReactComponent as Close } from "../../assets/icons/close2.svg";
import { Card } from "./Card";
import bgImage from "../../assets/images/bg-layer.jpg";
import arowleft from "../../assets/icons/Arrow-left.png";

export const Modal = ({
  children,
  goBack,
  modalHandle,
  billingAddress,
  noClose,
  /* Drop this wrapper's OWN box — its white ground, its padding, its rounded-md and its shadow — for a child that already draws a panel. */
  bare = false,
  closeButtonClass="absolute top-0 right-0 p-4 z-10",
  closeWidth=""
}) => {
  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center z-10">
        <div className="fixed inset-0  bg-opacity-10 backdrop-blur-sm"></div>
        <img
          className="fixed opacity-10 w-full "
          src={bgImage}
          alt="bg"
          onClick={modalHandle}
        />
        <Card
          classes={
            bare
              ? /* Position and the small-screen gutter only. */
                "relative z-10 m-2"
              : "relative z-10 bg-white py-4 px-4 rounded-md m-2 shadow-boxPopup"
          }
        >
          {billingAddress ? (
            <button
              onClick={modalHandle}
              className="absolute top-0 right-0 p-4 text-[#FB512D] flex align-center gap-1 z-10"
            >
              <img style={{ width: "20px" }} src={arowleft} alt="left" />
              {billingAddress}
            </button>
          ) : noClose ? null : (
            <button
              className={closeButtonClass}
              onClick={modalHandle}
            >
              <Close className={closeWidth} />
            </button>
          )}
          {children}
        </Card>
      </div>
    </>
  );
};
